
enum ClientID {
    ARC_FACILITY = 'd69c6394-60cb-44fb-b8be-f57776d8a14e',
    ARC_ADMIN = '5dfd0870-ede2-43c4-be4c-9a947a425c69',
    SKYSITE_ARCHIVE = '086648b5-3e54-4622-917c-62936d02983a',
    API_HUB = 'bd8c0793-f214-4771-9a8e-368c14791d7a',
    ARC_PRINT = '45043d72-2cb7-41df-953b-5e23edbcc992',
    ARC_CAPTURE = 'c16c91cb-e2ee-480e-b0cf-25c255aca72a',
}

const appConfig = {
  [ClientID.ARC_FACILITY]: {
    applicationId: 55,
    logoURL: "https://appstg.arcfacilities.com/assets/logo/facilities-logo.png",
    favicon:
      "https://d2dsx67ik4jg4k.cloudfront.net/assets/images/facility-favicon.ico",
    title: "ARC Facilities",
    themeColor: "red",
    stagingURL: "staging url",
    localURL: "local url",
    failureRedirect: "http://localhost:3002",
    origin: "https://appstg.arcfacilities.com",
    domain: ".arcfacilities.com",
    appType: "Enterprise",
    palette: {
      mode: "light",
      primary: {
        light: "rgba(11, 134, 214, 0.3)",
        main: "#e20008ff",
        dark: "#cd0006",
        contrastText: "#fff",
      },
      secondary: {
        light: "#D2D6DF",
        main: "#6C6E79",
        dark: "#000000",
        contrastText: "#fff",
      },
      info: {
        light: "#F4F4F5",
        main: "#F2F2F2",
        dark: "#8A8E9B",
        contrastText: "#000",
      },
      error: {
        main: "#e20008ff",
        dark: "#cd0006",
      },
    },
  },
  [ClientID.SKYSITE_ARCHIVE]: {
    applicationId: 3,
    logoURL: "https://appstg.skysite.com/assets/images/logo.png",
    favicon:
      "https://d2dsx67ik4jg4k.cloudfront.net/assets/images/skysite-favicon.ico",
    title: "SKYSITE",
    themeColor: "blue",
    stagingURL: "staging url",
    localURL: "local url",
    failureRedirect: "http://localhost:3002",
    origin: "https://appstg.skysite.com",
    domain: ".skysite.com",
    appType: "Enterprise",
    palette: {
      primary: {
        light: "rgba(11, 134, 214, 0.3)",
        main: "#0B86D6",
        dark: "#006DCA",
        contrastText: "#fff",
      },
      secondary: {
        light: "#6C6E79",
        main: "#6C6E79",
        dark: "#191B23",
        contrastText: "#fff",
      },
      info: {
        light: "#F4F4F5",
        main: "#F2F2F2",
        dark: "#8A8E9B",
        contrastText: "#000",
      },
    },
  },
  [ClientID.API_HUB]: {
    applicationId: 57,
    logoURL:
      "https://d2dsx67ik4jg4k.cloudfront.net/assets/images/apihub-logo.png",
    favicon:
      "https://d2dsx67ik4jg4k.cloudfront.net/assets/images/skysite-favicon.ico",
    title: "API HUB",
    themeColor: "blue",
    stagingURL: "staging url",
    localURL: "local url",
    failureRedirect: "http://localhost:3002",
    origin: "http://localhost:3002",
    domain: ".localhost",
    appType: "E-commerce",
    palette: {
      primary: {
        light: "rgba(11, 134, 214, 0.3)",
        main: "#0B86D6",
        dark: "#006DCA",
        contrastText: "#fff",
      },
      secondary: {
        light: "#6C6E79",
        main: "#6C6E79",
        dark: "#191B23",
        contrastText: "#fff",
      },
      info: {
        light: "#F4F4F5",
        main: "#F2F2F2",
        dark: "#8A8E9B",
        contrastText: "#000",
      },
    },
  },
  [ClientID.ARC_PRINT]: {
    applicationId: 1,
    logoURL: "https://www.arcprint.com/assets/media/arc-print-logo.svg",
    favicon: "https://www.arcprint.com/favicon.ico",
    title: "ARC Print",
    themeColor: "red",
    stagingURL: "staging url",
    localURL: "local url",
    failureRedirect: "http://localhost:3002",
    origin: "http://localhost:3002",
    domain: ".localhost",
    appType: "E-commerce",
    palette: {
      mode: "light",
      primary: {
        light: "rgba(11, 134, 214, 0.3)",
        main: "#ED1C24",
        dark: "#cd0006",
        contrastText: "#fff",
      },
      secondary: {
        light: "#D2D6DF",
        main: "#6C6E79",
        dark: "#000000",
        contrastText: "#fff",
      },
      info: {
        light: "#F4F4F5",
        main: "#F2F2F2",
        dark: "#8A8E9B",
        contrastText: "#000",
      },
      error: {
        main: "#ED1C24",
        dark: "#cd0006",
      },
    },
  },
  [ClientID.ARC_CAPTURE]: {
    applicationId: 1,
    logoURL: "https://stagingsbb.skysite.com/assets/logo/sbb_logo_black.svg",
    favicon:
      "https://d2dsx67ik4jg4k.cloudfront.net/assets/images/facility-favicon.ico",
    title: "ARC Capture",
    themeColor: "red",
    stagingURL: "staging url",
    localURL: "local url",
    failureRedirect: "http://localhost:3002",
    origin: "http://localhost:3002",
    domain: ".localhost",
    appType: "E-commerce",
    palette: {
      mode: "light",
      primary: {
        light: "rgba(11, 134, 214, 0.3)",
        main: "#ED1C24",
        dark: "#cd0006",
        contrastText: "#fff",
      },
      secondary: {
        light: "#D2D6DF",
        main: "#6C6E79",
        dark: "#000000",
        contrastText: "#fff",
      },
      info: {
        light: "#F4F4F5",
        main: "#F2F2F2",
        dark: "#8A8E9B",
        contrastText: "#000",
      },
      error: {
        main: "#ED1C24",
        dark: "#cd0006",
      },
    },
  },
  [ClientID.ARC_ADMIN]: {
    applicationId: 1,
    logoURL: "https://stagingsbb.skysite.com/assets/logo/sbb_logo_black.svg",
    favicon:
      "https://d2dsx67ik4jg4k.cloudfront.net/assets/images/facility-favicon.ico",
    title: "ARC Admin",
    themeColor: "red",
    stagingURL: "staging url",
    localURL: "local url",
    failureRedirect: "http://localhost:3002",
    origin: "http://localhost:3002",
    domain: ".localhost",
    appType: "E-commerce",
    palette: {
      mode: "light",
      primary: {
        light: "rgba(11, 134, 214, 0.3)",
        main: "#ED1C24",
        dark: "#cd0006",
        contrastText: "#fff",
      },
      secondary: {
        light: "#D2D6DF",
        main: "#6C6E79",
        dark: "#000000",
        contrastText: "#fff",
      },
      info: {
        light: "#F4F4F5",
        main: "#F2F2F2",
        dark: "#8A8E9B",
        contrastText: "#000",
      },
      error: {
        main: "#ED1C24",
        dark: "#cd0006",
      },
    },
  },
};

export function getClientConfig(clientID: string) {
    const config = appConfig[clientID as ClientID];
    if (!config) {
        //throw new Error(`Invalid clientID: ${clientID}`);
        return undefined;
    }

    // Merge config with environment-based settings
    return {
        ...config,

    };
}


export const pageTypeConfig = {
    account: 'account',
    address: 'address',
    // apps: 'apps',
    devices: 'devices',
    // subscription: 'subscription',
    security :'security'
}

export const MESSAGES = {
  emailSuccess: 'Email updated successfully',
  phoneSuccess: 'Phone number updated successfully',
  nameSuccess: 'Name updated successfully',
  passwordSuccess: 'Password change successful', 
  setPasswordSuccess: 'Password set successfully',
  addAddressSuccess: 'Address added successfully',
  updateAddressSuccess: 'Address updated successfully',
  deleteAddressSuccess: 'Address removed successfully',
  updateLanguageSuccess: 'Language updated successfully',
  updateTimezoneSuccess: 'Timezone updated successfully',
  securityCodeSuccess: 'Security code sent successfully',
  signoutSuccess: 'Signout Successfully',
}

export const webSocketMessage = {
  emailResponse : { success: true, description: "email updated" },
  phoneResponse : { success: true, description: "phone updated" },
  nameResponse : { success: true, description: "name updated" },
  imageResponse : { success: true, description: "image updated" },
  passwordResponse : { success: true, description: "password updated" },
  languageResponse : { success: true, description: "language updated" },
  timezoneResponse : { success: true, description: "timezone updated" },
  signoutResponse : { success: true, description: "signout updated" },
  sessionSignoutResponse : { success: true, description: "session signout updated" },
}

export const clientsType = {
  device : "device",
  cloud : "cloud"
}